const SUBSCRIBE_POPUP_DISMISS_UNTIL_KEY = "livall-subscribe-popup-dismissed-until";

function isDismissedBeforeExpiry() {
  const raw = localStorage.getItem(SUBSCRIBE_POPUP_DISMISS_UNTIL_KEY);
  if (!raw) return false;
  const until = Number(raw);
  return Number.isFinite(until) && Date.now() < until;
}

function getDismissDurationMs(el) {
  const dismissHours = Number(el.dataset.dismissHours);
  const safeHours = Number.isFinite(dismissHours) && dismissHours > 0 ? dismissHours : 168;
  return safeHours * 60 * 60 * 1000;
}

function getDelayMs(el) {
  const rawDelay = Number(el.dataset.delay);
  if (!Number.isFinite(rawDelay) || rawDelay <= 0) return 0;

  // Backward compatibility: historical values like 5000 were stored as milliseconds.
  if (rawDelay > 100) return rawDelay;

  return rawDelay * 1000;
}

function setDismissedUntil(el) {
  localStorage.setItem(
    SUBSCRIBE_POPUP_DISMISS_UNTIL_KEY,
    String(Date.now() + getDismissDurationMs(el))
  );
}

function isSubscribeFormSuccessReturn() {
  return (
    location.search.includes("customer_posted=true") &&
    location.hash === "#subscribePopup"
  );
}

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(".subscribe-popup");
  const overlay = document.querySelector(".subscribe-popup__overlay");
  const closeBtn = document.querySelector(".subscribe-popup-box-close");
  if (!el || !overlay || !closeBtn) return;
  const isProductPage = document.body && document.body.classList.contains("template-product");

  function dismiss() {
    el.classList.remove("active");
    setDismissedUntil(el);
  }

  overlay.addEventListener("click", function (e) {
    if (e.target.classList.contains("subscribe-popup__overlay")) {
      dismiss();
    }
  });

  closeBtn.addEventListener("click", function () {
    dismiss();
  });

  if (isSubscribeFormSuccessReturn()) {
    el.classList.add("active");
    return;
  }

  if (isProductPage) {
    return;
  }

  if (isDismissedBeforeExpiry()) {
    return;
  }

  let init = false;
  window.addEventListener("scroll", function () {
    if (init) return;
    init = true;

    if (!el.classList.contains("active")) {
      setTimeout(function () {
        el.classList.add("active");
      }, getDelayMs(el));
    }
  });
});
